import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenameShowTagDocument } from './rename.generated';

const useRename = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();

  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.show_tags.rename_error'),
      success: t('api.show_tags.rename_success'),
    }),
    ...options,
  });
};

export const useRenameShowTag = (options: ApiOptions<typeof RenameShowTagDocument> = {}) =>
  useRename(RenameShowTagDocument, options);
